import { render } from "./Mutation.vue?vue&type=template&id=4425c45a"
import script from "./Mutation.vue?vue&type=script&lang=js"
export * from "./Mutation.vue?vue&type=script&lang=js"

import exportComponent from "/home/adminhost/web/crevent.waroengss.id/public_html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__